// Customer dashboard + an admin-only "Ops view" tab. The Ops content is
// the same component served at /ops-dashboard (kept as a route alias so
// existing bookmarks/Slack links still resolve). For non-admins or while
// impersonating, the Ops tab is hidden entirely and the page renders the
// classic customer dashboard.
//
// Lazy mount: OpsDashboard is only mounted when the admin clicks its tab,
// so its API (adminGetOpsDashboard) doesn't fire on every /dashboard load.
import React, {useEffect, useState} from 'react'
import {Box, Tab, Tabs} from '@mui/material'
import Grid from '@mui/material/Grid'
import {connect} from 'react-redux'

import { dashboardSMSStats} from '../../actions/dashboard'
import {getSMSDetails} from '../../actions/sms';
import {isImpersonating} from '../../lib/impersonation'
import {getFromLocalStorage} from '../../lib/utils'
import OpsDashboard from '../OpsDashboard'
import Contact from './Contact'
import OfferUpdates from './OfferUpdates'
import QuickActions from './QuickActions'
import SMSUsage from './SMSUsage'

const ADMIN_ROLES = new Set([
  'platform_admin', 'admin', 'admin_agent', 'support_agent'
]);

const CUSTOMER_TAB = 0;
const OPS_TAB = 1;

const NewDashboard = ({
  getSMSDetails, dashboardSMSStats, dashboardData, smsStats, defaultTab
}) => {
  const role = (getFromLocalStorage() || {}).role;
  const opsTabVisible = ADMIN_ROLES.has(role) && !isImpersonating();

  // Admin can land here via /dashboard (defaultTab=undefined → Customer)
  // or /ops-dashboard (defaultTab='ops' → Ops). Clamp to Customer when
  // the Ops tab isn't visible to this user so a stale /ops-dashboard
  // bookmark loaded after a role change doesn't render a blank tab.
  const initialTab = defaultTab === 'ops' && opsTabVisible ? OPS_TAB : CUSTOMER_TAB;
  const [activeTab, setActiveTab] = useState(initialTab);

  useEffect(() => {
    // Customer-view APIs are needed for the KPI strip + header even when
    // the admin lands on the Ops tab (the chrome around the tabs reads
    // dashboardData / smsStats). Fire once on mount.
    getSMSDetails();
    dashboardSMSStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='dashboard-container'>
      {opsTabVisible && (
        <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
          <Tabs value={activeTab} onChange={(_e, v) => setActiveTab(v)}>
            <Tab label="Customer view" />
            <Tab label="Ops view" />
          </Tabs>
        </Box>
      )}

      {activeTab === CUSTOMER_TAB && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <QuickActions />
          </Grid>
          <Grid item xs={12}>
            <SMSUsage data={smsStats} dashboardData={dashboardData} />
          </Grid>
          <Grid item lg={8} md={7} xs={6}>
            <OfferUpdates />
          </Grid>
          {process.env.REACT_APP_IS_RESELLER !== 'true' &&
            <Grid item lg={4} md={5} xs={6}>
              <Contact />
            </Grid>
          }
        </Grid>
      )}

      {activeTab === OPS_TAB && opsTabVisible && <OpsDashboard />}
    </div>
  )
}

function mapStateToProps(state){
  return{
    dashboardData: state.smsResponse.smsDetailsResponse,
   // dashboardData : state.dashboard.dashboard,
    smsStats: state.dashboard.smsStats,
    // allGroupDetails : state.userResponse.contactGroupResponse
  }
}
export default connect(mapStateToProps,{getSMSDetails,dashboardSMSStats})(NewDashboard)
